import { render, staticRenderFns } from "./filtered_search_token.vue?vue&type=template&id=4b204251"
import script from "./filtered_search_token.vue?vue&type=script&lang=js"
export * from "./filtered_search_token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports